import { computed, makeObservable } from 'mobx';

import type { AuthStore } from '../auth/auth-store';

import { FULL_ACCESS_ROLE } from './roles';

export class RolesStore {
  private readonly authStore: AuthStore;

  constructor(authStore: AuthStore) {
    this.authStore = authStore;

    makeObservable(this);
  }

  @computed
  get userRoles(): string[] {
    const roles: string[] = [];

    this.authStore.userInfo?.realm_access?.roles?.forEach((r) => roles.push(r));
    this.authStore.userInfo?.resource_access?.goplan?.roles?.forEach((r) => roles.push(r));

    return roles;
  }

  hasAccess = (roles: string[]): boolean => {
    if (this.userRoles.includes(FULL_ACCESS_ROLE)) {
      return true;
    }

    for (const role of roles) {
      if (this.userRoles.includes(role.trim())) {
        return true;
      }
    }

    return false;
  };
}
